import { Component, effect, inject, input, OnInit, output, signal, ViewChild } from '@angular/core';
import { faDesktop, faMobile, faTablet, faArrowUpRightFromSquare, faEye } from '@fortawesome/pro-regular-svg-icons';

import { plainToClass } from 'class-transformer';

import { PreviewDevice, SurveyProgress, SurveyResult } from '@empathy/survey/base';
import { SURVEY_DEFAULT_LANGUAGE_CODE, SurveyModel } from '@empathy/survey-core';
import { SurveyViewerService, ViewerComponent } from '@empathy/survey-deprecated-viewer';

import { Notepad } from '../../models/notepad.model';

@Component({
  selector: 'empathy-notepad-full-preview',
  templateUrl: 'notepad-full-preview.component.html',
  styleUrls: ['./notepad-full-preview.component.scss', './_notepad-full-preview-theme.component.scss']
})
export class NotepadFullPreviewComponent implements OnInit {
  @ViewChild(ViewerComponent) surveyViewer: ViewerComponent;

  notepad = input<Notepad>();
  selectedActiveDevice = input<PreviewDevice>();

  previewCompleted = output();
  fullPreview = output();

  defaultLanguageCode$ = inject(SURVEY_DEFAULT_LANGUAGE_CODE);
  activeDevice$ = signal<PreviewDevice>(PreviewDevice.Desktop);
  surveyModel$ = signal<SurveyModel>(null);
  isProgressSaved$ = signal(false);

  faArrowUpRightFromSquare = faArrowUpRightFromSquare;
  faDesktop = faDesktop;
  faEye = faEye;
  faMobile = faMobile;
  faTablet = faTablet;
  previewDevice = PreviewDevice;

  private MOCK_SAVE_DELAY_MS = 100;

  private surveyViewerService = inject(SurveyViewerService);

  constructor() {
    effect(
      () => {
        if (this.notepad()) {
          this.surveyModel$.set(plainToClass(SurveyModel, JSON.parse(this.notepad().surveyJson)));
        }
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {
    this.surveyViewerService.activePageIndex$.set(-1);
    this.surveyViewerService.isTestMode$.set(true);

    this.notepad().form.valueChanges.subscribe(() => {
      this.surveyViewerService.activePageIndex$.set(-1);
      this.surveyModel$.set(plainToClass(SurveyModel, JSON.parse(this.notepad().surveyJson)));
    });
  }

  onPreviewStarted(): void {
    console.warn('Survey started');
  }

  onPreviewCompletedSurvey(saveEvent: { results: SurveyResult; autocomplete: boolean }): void {
    console.warn(saveEvent);
  }

  onPreviewProgress(progress: SurveyProgress): void {
    this.isProgressSaved$.set(false);
    console.warn('JSON', JSON.parse(progress.answerJson));
    console.warn('Submitted question ids', progress.submittedQuestionIds);
    setTimeout(() => {
      this.isProgressSaved$.set(true);
    }, this.MOCK_SAVE_DELAY_MS);
  }

  onPreviewCompleted(): void {
    console.warn('Survey completed');
    this.surveyViewerService.activePageIndex$.set(-1);
    this.surveyViewer.showEndPage$.set(false);
    this.previewCompleted.emit();
  }
}
